import React, { Fragment, useState } from 'react';
import { useFetch } from '../../../lib/useFetch';
import { Container, Grid, Table, Card, Button, Page, Dimmer, Avatar } from "tabler-react";
import PaginationBar from '../../../components/pagination';
import SearchInput from '../../../components/searchInput';
import { useHistory } from 'react-router-dom';

const Categories = ({ openMainModal }) => {
  const [page, setPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  const [reload, toggleReload] = useState(false)

  const onSearch = (term) => {
    setSearchQuery(term);
    setPage(1);
  };

  const searchParam = searchQuery ? `&search=${encodeURIComponent(searchQuery)}` : '';
  const { data, loading, totalCount } = useFetch(`categories?page=${page}${searchParam}`, reload);
  const history = useHistory()

  return (
    <Fragment>
      <Container>
        <Page.Header>
          <Page.Title>Categories</Page.Title>
        </Page.Header>
        <Grid>
          <Grid.Row>
            <Card>
              <Dimmer active={loading} loader={loading}>
                <Card.Header>
                  <Card.Options>
                    <SearchInput value={searchQuery} onSubmit={onSearch} />
                    <Button
                      className="ml-2"
                      icon="plus"
                      color="primary"
                      size="md"
                      onClick={() => openMainModal('category-create', null, () => toggleReload(r => !r))}
                    >
                      Create Category
                    </Button>
                    <Button
                      className="ml-2"
                      icon="plus"
                      color="secondary"
                      size="md"
                      onClick={() => openMainModal('sub-category-create')}
                    >
                      Create SubCategory
                    </Button>
                  </Card.Options>
                </Card.Header>

                {!loading && (!data || data.length < 1) ? (
                  <div className="alert alert-primary m-0">
                    No Categories to show!
                  </div>
                ) : (
                  <div className="table-responsive-wrapper">
                    <Table hasOutline striped>
                      <Table.Header>
                        {['icon', 'image', 'name'].map((head, i) => (
                          <Table.ColHeader key={`tableHeader-${i}`}>
                            {head}
                          </Table.ColHeader>
                        ))}
                        <Table.ColHeader>Actions</Table.ColHeader>
                      </Table.Header>
                      <Table.Body>
                        {data && data.map(({ name, image, icon, _id }, i) => (
                          <Table.Row key={i}>
                            <Table.Col>
                              <Avatar size="sm" imageURL={icon} />
                            </Table.Col>

                            <Table.Col>
                              <Avatar size="md" imageURL={image} />
                            </Table.Col>

                            <Table.Col>
                              {name}
                            </Table.Col>

                            <Table.Col>
                              <div className="actions-wrap">
                                <Button
                                  outline
                                  color="secondary"
                                  size="sm"
                                  onClick={() => openMainModal('category-edit', _id, () => toggleReload(r => !r))}
                                >
                                  Edit
                                </Button>

                                <Button
                                  outline
                                  color="danger"
                                  className="ml-2 mr-2"
                                  size="sm"
                                  onClick={() => openMainModal('categories--delete', _id, () => toggleReload(r => !r))}
                                >
                                  Delete
                                </Button>

                                <Button
                                  outline
                                  color="secondary"
                                  size="sm"
                                  onClick={() => history.push(`/products/categories/${_id}/subcategories`)}
                                >
                                  View Subcategories
                                </Button>
                              </div>
                            </Table.Col>
                          </Table.Row>
                        ))}
                      </Table.Body>
                    </Table>
                  </div>
                )}

                {data && data.length > 0 && (
                  <PaginationBar
                    page={page}
                    totalCount={totalCount}
                    setPage={setPage}
                  />
                )}
              </Dimmer>
            </Card>
          </Grid.Row>
        </Grid>
      </Container>
    </Fragment>
  );
}

export default Categories;